import api from './api';

export const getFeatures = async () => {
  const { data } = await api.get('/features');
  return data;
};
export const createFeature = async (name) => {
  const { data } = await api.post('/features', { name });
  return data;
};
export const updateFeature = async (id, params) => {
  const { data } = await api.put(`/features/${id}`, params);
  return data;
};
export const deleteFeature = async (id) => {
  const { data } = await api.delete(`/features/${id}`);
  return data;
};
